<template>
<div id="page-carga_ctm" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Bitácora de Carga CTM" class="elevation-1 px-5 py-3" >
                   
                <v-tabs grow style="margin-bottom: 30px;" >
                <v-tabs-slider color="primary" ></v-tabs-slider>
                <v-tab :key="'carga_layout'" >Carga Layout</v-tab>                
                <v-tab :key="'reporte'" >Reportes CTM</v-tab>

                <v-tab-item :key="'carga_layout'" >

                    <v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>                            
                            <v-btn fab dark x-small color="purple darken-2" title="Ejemplo Layout CSV" v-tippy @click="generateCSV()">
                                <v-icon dark>receipt</v-icon>
                            </v-btn>
                            <v-btn fab dark x-small color="blue darken-1" title="Cargar Layout CSV" v-tippy @click="openModal()">
                                <v-icon dark>cloud_upload</v-icon>
                            </v-btn>
                            <v-btn v-show="es_super" fab dark x-small color="red darken-1" title="Cargar Layout Histórico CSV" v-tippy @click="openModalMasivoCSV()">
                                <v-icon dark>mdi-file-upload</v-icon>
                            </v-btn>
                            <v-btn v-show="es_super" fab dark x-small color="orange darken-1" title="Cargar ZIP Masivo de PDFs" v-tippy @click="openModalMasivoPDF()">
                                <v-icon dark>mdi-zip-box</v-icon>
                            </v-btn>&nbsp;
                            <exportar-excel
                                :data="datos"
                                :exportFields="encabezados_excel"
                                name="BitacoraCTM.xlsx">
                                <v-btn fab sark x-small color="green darken-1" title="Exportar" v-tippy>
                                    <v-icon dark>mdi-file-excel</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-card-actions>
                        <v-card-text>

                            <v-card-actions>
                                <v-refresh-button :funcion="cargar" />
                                <v-spacer></v-spacer> 
                                <!--v-btn v-show="es_super" dark small color="red darken-1" title="Eliminar registros con error y eliminados" 
                                    v-tippy @click="eliminarRegistroMasivo()">
                                    <v-icon dark>delete</v-icon> Borrar Registros Eliminados y con Error
                                </v-btn-->
                            </v-card-actions>
                            <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                            <template slot="noResults" >
                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                            </template>
                            <template slot="lineas_insertadas" slot-scope="props">
                                <div style="text-align:right;">
                                    {{ formatNumberDecCero(props.row.lineas_insertadas,0) }}
                                </div>
                            </template>

                            <template slot="actions" slot-scope="props" >
                                <v-btn text icon color="red" v-show="(props.row.key_pdf && props.row.key_pdf!='')" title="Descargar PDF" @click="downloadFile(props.row.key_pdf)" >
                                    <v-icon dark>mdi-file-pdf-box</v-icon>
                                </v-btn>
                                <v-btn text icon color="purple darken-2" title="Actualizar PDF" @click="show_modal_pdf(props.row._id)" >
                                    <v-icon dark>mdi-file-plus</v-icon>
                                </v-btn>
                                <v-btn text icon color="primary" title="Descargar Archivo" @click="downloadFile(props.row.key)" >
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                                <v-btn text icon color="secondary" v-show="(props.row.key_acuse && props.row.key_acuse!='')" title="Descargar Acuse" @click="downloadFile(props.row.key_acuse)" >
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                                <v-btn text icon color="blue" title="Eliminar Información" v-show="props.row.estatus=='Correcto'" @click="eliminar(props.row._id, props.row.archivo)" >
                                    <v-icon dark>cancel</v-icon>
                                </v-btn>
                                <v-btn text icon color="red" title="Eliminar Registro" v-show="es_super && ['Error','Eliminado'].includes(props.row.estatus)" @click="eliminarRegistro(props.row._id, props.row.archivo)" >
                                    <v-icon dark>delete_forever</v-icon>
                                </v-btn>
                            </template>
                            </v-client-table>

                            
                        </v-card-text>
                        
                    </v-card-text>
                </v-tab-item>
                

                <v-tab-item :key="'reporte'" >
                    <v-card-text>
                                <v-form ref="formreporte" lazy-validation>
                                    <v-row>
                                        <v-col sm="12" md="5" lg="5">
                                            <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Periodo Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"></v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu3 = false" type="month">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu3 = false">
                                                Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col sm="12" md="5" lg="5">
                                            <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Periodo Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                                :rules="[verificaPedimento, verificaTipoConsulta, validaAnio, validaFecha]"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" type="month">
                                                <v-spacer />

                                                <v-btn color="secondary" x-small @click="menu4 = false">
                                                Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                            </v-menu>
                                        </v-col>                                                                 
                                    </v-row>
                                    <v-row>
                                        <v-col sm="12" md="2" lg="2" style="margin-top:-35px;">
                                            <v-radio-group v-model="model.tipo_consulta" label="Tipo de Listado:">
                                            <v-radio label="No. de Folio" value="folios" />
                                            <v-radio label="No. de Parte" value="partes" />                                            
                                            </v-radio-group>
                                        </v-col>
                                        <v-col sm="12" md="1" lg="1">
                                            <v-btn icon :title="'Buscar por'+ (model.tipo_consulta=='folios'?' Folio CTM':' No. Parte')" @click="dialog1 = !dialog1" v-tippy>
                                            <v-icon colorHover="secondary" size="48">mdi-clipboard-list-outline</v-icon>
                                            </v-btn>
                                        </v-col>                            
                                        <v-col sm="12" md="2" lg="2">
                                            Total de elementos en la lista: <strong>{{lista_filtrada.length}}</strong>
                                        </v-col>
                                        <v-col sm="12" md="7" lg="7">
                                            <v-combobox v-model="lista_filtrada" :label="'Lista de'+ (model.tipo_consulta=='folios'?' Folios CTM':' No. Partes')" multiple persistent-hint small-chips disabled color="green">
                                            </v-combobox>
                                        </v-col>
                                    </v-row>
                                    <v-row wrap>   
                                        <v-col xs="12" lg="4" md="4">
                                            <v-autocomplete v-model="model.rfc_iat" label="Filtrar por Emisor IAT" :items="emisoresArray"  
                                                item-value="rfc" item-text="nombre_completo" 
                                                clearable :hide-no-data="true">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col xs="12" lg="4" md="4">
                                            <v-autocomplete v-model="model.mercado_exportacion" label="Filtrar por Apartado CTM - Partes y Componentes" 
                                            :items="[
                                                {'name':'A - Destinados al Mercado Nacional','clave':'A'},
                                                {'name':'B - Exportados a Países distintos de EUA CN estados miembros de la comunidad o de la AELC','clave':'B'},
                                                {'name':'C - Exportados a los EUA CN estados miembros de la comunidad o de la AELC','clave':'C'},
                                                {'name':'C-1 - Estados Unidos de América o Canadá estados miembros de la comunidad','clave':'C-1'},
                                                {'name':'C-2 - Estados miembros de la comunidad','clave':'C-2'},
                                                {'name':'C-3 - Estados miembros de la AELC','clave':'C-3'},
                                                ]"  
                                            item-text="name" item-value="clave" clearable
                                            :hide-no-data="true">
                                    </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-form>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>

                                        <v-btn color="success" @click="generar_reporte_sqs" >
                                            <v-icon>done</v-icon>Generar Reporte
                                        </v-btn>
                                    </v-card-actions>

                                    
                                        <v-refresh-button :funcion="cargarReportes" />
                                        <v-client-table ref="vuetable" :data="datos_reportes" :columns="columns_reportes" :options="options_reportes" class="elevation-2 pa-2" >
                                        <template slot="noResults" >
                                            <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                        </template>

                                        <template slot="actions" slot-scope="props" >
                                            <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                                                <v-icon dark>get_app</v-icon>
                                            </v-btn>
                                            <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                                                <v-icon dark>delete</v-icon>
                                            </v-btn>
                                        </template>
                                        </v-client-table>

                                        
                                    </v-card-text>
                </v-tab-item>
                </v-tabs>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

    <v-dialog v-model="modal" max-width="55%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Cargar Archivo CSV</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <v-form ref="formdatos" lazy-validation>
                        <v-container grid-list-md>
                            <v-row wrap>   
                                <v-col xs="12" lg="8" md="8">
                                    <v-autocomplete v-model="rfc_iat" label="Seleccione RFC de la IAT" :items="emisoresArray" 
                                        item-value="rfc" item-text="nombre_completo" 
                                        :hide-no-data="true" :rules="[rules.required]">
                                    </v-autocomplete>
                                </v-col>
                                <v-col xs="12" lg="4" md="4" style="font-weight:bold;">
                                    <br>
                                    <strong>{{getMetadatoEmisor(rfc_iat)}}</strong>
                                </v-col>
                            </v-row>
                            <v-row wrap>   
                                <v-col xs="12" lg="4" md="4">
                                    <v-text-field label="# Folio CTM" v-model='folio_ctm' :rules="[rules.required]" @input="folio_ctm = folio_ctm.toString().toUpperCase()"></v-text-field>
                                </v-col>
                                <v-col xs="12" lg="4" md="4">
                                    <v-autocomplete v-model="tipo_documento" label="Tipo Documento" :items="['Original','Complementario']"  
                                        :hide-no-data="true" :rules="[rules.required]">
                                    </v-autocomplete>
                                </v-col>
                                <v-col xs="12" lg="4" md="4">
                                    <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="fecha_expedicion" label="Fecha Expedición" color="secondary" prepend-icon="event" @blur="fecha_expedicion = parseDate(fecha_expedicion)" v-mask="'####-##-##'"
                                            :rules="[rules.required, validaFecha]"></v-text-field>
                                        </template>

                                        <v-date-picker v-model="fecha_expedicion" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu1 = false">
                                            Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                            <v-row wrap>   
                                <v-col xs="12" lg="4" md="4" style="text-align:center !important;">     
                                    <br>                              
                                    <strong>Seleccione Periodo:</strong>
                                </v-col>
                                <v-col xs="12" lg="4" md="4">
                                    <v-autocomplete v-model="anio" label="Seleccione Año" :items="anios"  
                                        :hide-no-data="true" :rules="[rules.required]">
                                    </v-autocomplete>
                                </v-col>
                                <v-col xs="12" lg="4" md="4">
                                    <v-autocomplete v-model="mes" label="Seleccione Mes" :items="meses"  
                                        :hide-no-data="true" :rules="[rules.required]">
                                    </v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col xs="12" lg="6" md="6">
                                    <v-text-field label="Seleccione Layout CSV con Información CTM" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                    <input type="file" style="display: none" ref="file_input" accept=".csv" @change="onFilePicked" >                                    
                                </v-col>                            
                                <v-col xs="12" lg="6" md="6">
                                    <v-text-field label="Seleccione PDF Documento CTM" @click='pickFilePdf' v-model='name_file_pdf' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                    <input type="file" style="display: none" ref="file_input_pdf" accept=".pdf" @change="onFilePickedPdf" >
                                </v-col>
                            </v-row>        
                        </v-container>
                    </v-form>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modal = false" >
                        <v-icon>cancel</v-icon>Cancelar
                    </v-btn> 
                    <v-btn color="success" @click.native="guardarDatos()" >
                        <v-icon>done</v-icon>Guardar
                    </v-btn> 
                    
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog1" max-width="500px">
            <v-card>
            <v-card-text>
                <h5>Ingrese lista de {{ (model.tipo_consulta=='folios'?' Folios CTM':' No. Partes')}}</h5>
                <span>Uno por línea</span><br>        
                <v-form ref="formListado" lazy-validation="">
                <v-textarea outlined rows="15" v-model="model.lista" :rules="[rules.required, maxListaRule]"></v-textarea>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn small @click="model.lista=''; lista_filtrada=[]; dialog1 = false">Cancelar</v-btn>
                <v-btn small color="primary" @click="setListValues();">Buscar</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modal_pdf" max-width="35%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modal_pdf = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Actualizar Archivo PDF</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <v-form ref="formpdf" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col xs="12" lg="12" md="12">
                                    <v-text-field label="Seleccione PDF Documento CTM" @click='pickFilePdf' v-model='name_file_pdf' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                    <input type="file" style="display: none" ref="file_input_pdf" accept=".pdf"  @change="onFilePickedPdf" >
                                </v-col>
                            </v-row>        
                        </v-container>
                    </v-form>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modal_pdf = false" >
                        <v-icon>cancel</v-icon>Cancelar
                    </v-btn> 
                    <v-btn color="success" @click.native="guardarPDF()" >
                        <v-icon>done</v-icon>Guardar PDF
                    </v-btn> 
                    
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modal_masivo_csv" max-width="35%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modal_masivo_csv = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Archivo Histórico CSV</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <v-form ref="formpdf" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col xs="12" lg="12" md="12">
                                    <v-text-field label="Seleccione CSV" @click='pickFileCsv' v-model='name_file_masivo_csv' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                    <input type="file" style="display: none" ref="file_input_masivo_csv" accept=".csv"  @change="onFilePickedMasivoCsv" >
                                </v-col>                                
                            </v-row>                                 
                        </v-container>
                    </v-form>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modal_masivo_csv = false" >
                        <v-icon>cancel</v-icon>Cancelar
                    </v-btn> 
                    <v-btn color="success" @click.native="guardarMasivoCSV()" >
                        <v-icon>done</v-icon>Guardar
                    </v-btn> 
                    
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modal_masivo_pdf" max-width="35%" style=" z-index: 400 !important;" >
            <v-card>
                <v-card-title>
                    <v-card class="primary white--text titulomodal" >
                        <v-icon @click.native="modal_masivo_pdf = false" class="white--text" >cancel</v-icon>&nbsp;
                        <span class="subheading" >
                            <strong>Cargar ZIP Masivo con PDFs</strong>
                        </span>
                    </v-card>                    
                </v-card-title>
                <v-card-text>
                    <span style="font-weight:bold;">El nombre de los archivos PDF dentro del Zip, deben ser nombrados con el número de folio al que pertenece: Por ejemplo: CTM012025RFC0123.pdf</span><br>
                    <span>Solo se guardarán los PDFs de los folios que ya se encuentren registrados.</span>
                    <v-form ref="formpdf" lazy-validation>
                        <v-container>
                            <v-row>
                                <v-col xs="12" lg="12" md="12">
                                    <v-text-field label="Seleccione ZIP" @click='pickFileZip' v-model='name_file_masivo_pdf' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                    <input type="file" style="display: none" ref="file_input_masivo_pdf" accept=".zip"  @change="onFilePickedMasivoPdf" >
                                </v-col>
                            </v-row>        
                        </v-container>
                    </v-form>
                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click.native="modal_masivo_pdf = false" >
                        <v-icon>cancel</v-icon>Cancelar
                    </v-btn> 
                    <v-btn color="success" @click.native="guardarMasivoPDF()" >
                        <v-icon>done</v-icon>Guardar
                    </v-btn> 
                    
                </v-card-actions>
            </v-card>
        </v-dialog>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Vue from "vue";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
    components: {
        "v-refresh-button": RefreshButton,
    },
    created: function () {
        this.model.rfc = this.$local_storage.get("rfc");
        this.model.usuario = this.$local_storage.get("id_usuario");
        this.cliente = this.$local_storage.get("id_cliente");  
        this.rfcActual = this.$local_storage.get("rfc");
        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
            this.es_super = true;
            this.permisoEliminar = true;
        }        
        var anio_actual = parseInt(moment().format("YYYY"));        
        for (var i = 2000; i <= anio_actual; i++) {//2015 a la fecha
            this.anios.push(i);        
        }
        this.anios.reverse();        
        this.getEmisores();
        this.selecciona_obligatorios();
        this.get_campos();
        this.cargar();    
        this.cargarReportes();
    },
    data() {
        return {
            modal_masivo_pdf:false,
            modal_masivo_csv:false,
            modal_pdf:false,
            id_bitacora_seleccionado:'',
            anios:[],
            meses:[1,2,3,4,5,6,7,8,9,10,11,12],

            dialog1: false,
            lista_filtrada: [],
            model: {
                rfc: "",
                usuario: "",
                reporte_url: "/soluciona24/reportes/rpt_ctm/",
                nombre_reporte: "CTM",
                tipo: "SA24_CTM",

                fecha_de: "",
                fecha_a: "",                
                lista: '',                
                rfc_iat:"",
                mercado_exportacion:"",
                tipo_consulta: "folios", //folios|partes
            },

            menu1: false,
            menu2: false,
            menu3: false,
            menu4: false,
            
            //reportes
            datos_reportes: [],
            columns_reportes: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
            options_reportes: {
                filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
                sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

                headings: {
                    id: "No. Proceso",
                    fecha_solicitud: "Solicitado",
                    usuario_email: "Usuario",
                    nombre_reporte: "Reporte",   
                    "criterio":"Criterio",
                    fecha_generacion: "Generado",
                    estatus: "Estatus",
                    error: "Error",
                    actions: "Descargar"
                }
            },

            fecha_expedicion: "",
            anio: "",
            mes: "",
            rfc_iat: "",
            razon_social_iat: "",
            tipo_documento: "",
            folio_ctm:"",
            menu1:false,
            emisoresArray: [],
            emisores: [],
            
            es_super:false,
            selecciona_todo: false,
            campos_seleccionados:[],
            arr_campos:[
                {"nombre":"NUMERO DE FOLIO DE LA CTM", "obligatorio":true},
                {"nombre":"PERIODO DE EMISIÓN CTM", "obligatorio":true},
                {"nombre":"SECUENCIA", "obligatorio":false},                              
                {"nombre":"EMISOR IAT", "obligatorio":true},
                {"nombre":"NUMERO DE PARTE", "obligatorio":true},
                {"nombre":"DESCRIPCIÓN", "obligatorio":false},
                {"nombre":"CANTIDAD", "obligatorio":true},
                {"nombre":"PEDIMENTO", "obligatorio":false},
                {"nombre":"ADUANA", "obligatorio":false},
                {"nombre":"FECHA DE PEDIMENTO", "obligatorio":false},
                {"nombre":"MERCADO DE EXPORTACION", "obligatorio":true},
                {"nombre":"PAIS DE EXPORTACION", "obligatorio":false},
                {"nombre":"COMENTARIOS", "obligatorio":false},                              
            ],                             
            datos: [],
            columns: ["fecha", "usuario_name", "archivo", "folio_ctm", "periodo", "lineas_insertadas", "tipo_documento", "rfc_iat", "emisor", "estatus", "error", "usuario_elimino_name", "fecha_elimino", "actions"],
            options: {
                filterable: ["fecha", "usuario_name", "archivo","folio_ctm", "periodo", "lineas_insertadas", "tipo_documento", "rfc_iat", "emisor", "estatus", "error", "usuario_elimino_name", "fecha_elimino"],
                sortable: ["fecha", "usuario_name", "archivo", "folio_ctm", "periodo", "lineas_insertadas", "tipo_documento", "rfc_iat", "emisor", "estatus", "error", "usuario_elimino_name", "fecha_elimino"],

                headings: {
                    "fecha":"Fecha", 
                    "usuario_name":"Usuario", 
                    "archivo":"Archivo",        
                    "folio_ctm":"#CTM", 
                    "periodo":"Periodo", 
                    "tipo_documento":"Tipo Documento", 
                    "rfc_iat":"RFC IAT", 
                    "emisor":"Emisor",             
                    "lineas_insertadas":"Registros Totales",
                    "estatus":"Estatus", 
                    "error":"Error",
                    "usuario_elimino_name":"Usuario Eliminó", 
                    "fecha_elimino":"Fecha Eliminó",
                    actions: "Descargar"
                }
            },
            encabezados_excel: {
                    "Fecha":"fecha", 
                    "Usuario":"usuario_name", 
                    "Archivo":"archivo",        
                    "#CTM":"folio_ctm", 
                    "Periodo":"periodo", 
                    "Tipo Documento":"tipo_documento", 
                    "RFC IAT":"rfc_iat", 
                    "Emisor":"emisor",             
                    "Registros Totales":"lineas_insertadas",
                    "Estatus":"estatus", 
                    "Error":"error",
                    "Usuario Eliminó":"usuario_elimino_name", 
                    "Fecha Eliminó":"fecha_elimino",
            },
            rfcActual:"",
            fab: false,
            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Solución A24",
                    disabled: true,
                    href: ""
                },
                {
                    text: "Bitácora de Carga CTM",
                    disabled: true,
                    href: ""
                }
            ],            
            modal: false,            

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,            
            archivo_original: "",

            name_file_pdf: "",
            archivo_original_pdf: "",
            
            name_file_masivo_csv: "",
            archivo_original_masivo_csv: "",
            name_file_masivo_pdf: "",
            archivo_original_masivo_pdf: "",

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {
        setListValues: function() {
            this.lista_filtrada = [];
            let to_list = this.get_array_lista(this.model.lista);
            for (var i = 0; i < to_list.length; i++) {
                if (this.lista_filtrada.includes(to_list[i])) {
                continue;
                } else {
                this.lista_filtrada.push(to_list[i]);
                }
            }
            if(this.model.tipo_consulta == "folios"){//Que solo borre cuando sea busqueda por folios
                this.model.fecha_de = "";
                this.model.fecha_a = "";
            }            
            this.dialog1 = !this.dialog1;
        },
        get_array_lista: function(cadena) {
            try {
                var newarr = [];
                if (cadena != undefined) {
                let data = cadena.split("\n");
                newarr = data.filter(a => a.trim() !== '');
                for (var i = 0; i < newarr.length; i++) {
                    newarr[i] = newarr[i].trim();
                    newarr[i] = newarr[i].replace(',', '');
                    newarr[i] = newarr[i].replace('.', '');
                }
                }
                return newarr;
            } catch (error) {
                console.log(error);
            }
        },  
        verificaPedimento: function() {
            if (this.model.lista != '' && this.model.lista != null && this.model.lista.length > 0) {
                return true;
            }
            if (this.model.fecha_de == "" || this.model.fecha_a == "") {
                return "Favor de ingresar fechas o listado";
            }
            return true;
        },
        verificaTipoConsulta: function() {            
            if (this.model.tipo_consulta == "partes" && (this.model.fecha_de == "" || this.model.fecha_a == "")) {
                return "Favor de ingresar fechas cuando el listado es por No. Parte";
            }
            return true;
        },
        maxListaRule: function() {
            if (this.model.lista == '' || this.model.lista == undefined || Array.isArray(this.model.lista)) {
                return "Lista vacia";
            }

            let x = this.model.lista.split("\n");

            if (x.length > 15) {
                return "No se puede consultar mas de 15 folios/no. partes";
            } /*else if (x.length > 0) {
                for (var k in x) {
                if (!this.validarPatronPedimento(x[k]))
                    return "Verificar pedimentos no válidos. Ejemplo correcto: 15-07-0123-0000123";
                }
            }*/

            return true;
        }, 
        cargarReportes: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.rfcActual,
                "tipo": "SA24_CTM"
            };
            axios.post(this.$apiSA31+ "soluciona31/reportes/get_reportes/", data)
                .then(res => {
                    if (res.data != undefined) {
                        this.datos_reportes = res.data;
                        this.datos_reportes.sort(function(a, b) {
                            //Ordenar por fecha más reciente
                            return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
                        });
                        for (var k in this.datos_reportes) {
                            this.datos_reportes[k].fecha_solicitud = this.parseDate(this.datos_reportes[k].fecha_solicitud);
                            this.datos_reportes[k].fecha_generacion = this.parseDate(this.datos_reportes[k].fecha_generacion);
                            this.datos_reportes[k].estatus = this.getEstatus(this.datos_reportes[k].estatus);
                            this.datos_reportes[k].criterio = this.getCriterio(this.datos_reportes[k].criterio);
                        }
                    }
                }).catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los reportes.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getEstatus: function(estatus) {
            var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
            if (estatus in arr_estatus)
                return arr_estatus[estatus];
            else
                return "N/A";
        },
        getCriterio: function(criterio) {
            try {
                if (criterio != undefined && criterio.toString().trim() != "") {
                    var params = JSON.parse(criterio);
                    var mensaje = "";
                    if (params.fecha_de && params.fecha_de!=""){
                        mensaje += "Periodo: "+params.fecha_de;                        

                        if (params.fecha_a && params.fecha_a!=""){
                            mensaje += " a "+params.fecha_a;                        
                        }
                    } 
                    if(params.lista != undefined && params.lista != "") {
                        mensaje += " Listado de Folios";
                    } 
                    if (params.rfc_iat && params.rfc_iat!=""){
                        mensaje += ", Emisor: "+params.rfc_iat;                        
                    }
                    if (params.mercado_exportacion && params.mercado_exportacion!=""){
                        mensaje += ", Apartado: "+params.mercado_exportacion;                        
                    } 
                    
                    return mensaje;
                } else {
                    return "N/A";
                }
            } catch (error) {
                console.log(error);
                return "N/A-error";
            }
        },
        validaFecha: function(fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida.";
            else
                return true;
        },
        validaAnio: function() {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
                if (Math.abs(diferencia) > 366)
                    return "Periodo máximo de consulta un año. Favor de verificar."
            }
            return true;
        },
        openModal: function(){
            this.modal = true;
            this.reset();
            this.fecha_expedicion = "";
            this.anio = "";
            this.mes = "";
            this.rfc_iat = "";
            this.razon_social_iat = "";
            this.tipo_documento = "";
            this.folio_ctm = "";            
        },
        openModalMasivoCSV: function(){
            this.resetMasivoCSV();
            this.modal_masivo_csv = true;            
        },
        openModalMasivoPDF: function(){
            this.modal_masivo_pdf = true;
            this.resetMasivoPDF();
        },
        getEmisores: function(){
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios.post(this.$hostname + "catalogos/emisores_destinatarios/get_emisores/", datos)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.emisores = res.data;
                    for(var k in this.emisores){
                        this.emisoresArray.push({"rfc":this.emisores[k].rfc, "nombre_completo":this.emisores[k].rfc +" - "+this.emisores[k].razon_social})    
                    }
                    this.emisoresArray.sort(function(a, b) {
                        //Ordenar por fecha más reciente
                        return b.rfc - a.rfc;
                    });
                    //console.log("Emisores: ", this.emisores);
                }
            })
            .catch(err => {                                       
                console.log("Error al obtener emisores", err);
            });
        },
        getNombreEmisor: function(rfc){
            var emisor = this.emisores.find(e => e.rfc == rfc);
            if(emisor){
                return emisor.razon_social;
            } else {
                return rfc;
            }
        },
        getMetadatoEmisor: function(rfc){
            var emisor = this.emisores.find(e => e.rfc == rfc);
            if(emisor){
                return emisor.metadato;
            } else {
                return rfc;
            }
        },
        verificaCampos: function(){
            if (this.campos_seleccionados.length == 0) {                
                return "Seleccione un Campo";
            } else {                
                return true;
            }
        },
        seleccionaTodo: function(){
            if (this.selecciona_todo == true){
                var thisObj = this;
                this.campos_seleccionados = [];
                this.arr_campos.forEach(e => {
                    thisObj.campos_seleccionados.push(e.nombre);
                });
            } else {
                this.campos_seleccionados = [];
                this.selecciona_obligatorios();
            }
        },
        selecciona_obligatorios: function(){
            this.arr_campos.forEach(e => {
                if(e.obligatorio){
                    this.campos_seleccionados.push(e.nombre);
                }
            });
        },
        get_campos: function() {
            
            let data = {
                rfc: this.rfcActual,
                tipo: "CTM" //entradas|salidas|descargos|activo_fijo|saldos|CTM
            };
            axios.post(this.$apiSA31 + 'soluciona24/get_campos_reporte/', data)                        
            .then(res => {
                if (typeof res.data !== "undefined") {
                    if(res.data.length > 0)
                        this.campos_seleccionados = res.data;
                    else {
                        //Si no tiene ninguno guardado, que los seleccione todos
                        this.campos_seleccionados = [];
                        this.arr_campos.forEach(e => {  
                                this.campos_seleccionados.push(e.nombre);                            
                        });                        
                    }
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los campos guardados.",
                    footer: ""
                });
                console.log(err);

            });
        },
        guarda_campos: function() {

            if (this.$refs.form.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    rfc: this.rfcActual,
                    tipo: "CTM", //entradas|salidas|descargos|activo_fijo|saldos|CTM
                    campos: this.campos_seleccionados,
                    id_usuario: this.$local_storage.get("id_usuario")
                };
                axios.post(this.$apiSA31 + 'soluciona24/guardar_campos_reporte/', data)                                      
                .then(res => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "La información se guardó correctamente",
                        footer: ""
                    });
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al guardar los campos. Intente nuevamente por favor.",
                        footer: ""
                    });
                    console.log(err);

                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
            }
                        
        },
        pickFile() {
            this.$refs.file_input.click();
        },
        pickFilePdf() {
            this.$refs.file_input_pdf.click();
        },
        pickFileCsv() {
            this.$refs.file_input_masivo_csv.click();
        },
        pickFileZip() {
            this.$refs.file_input_masivo_pdf.click();
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;
                    this.archivo_original = files[0];
                    if (this.name_file.lastIndexOf('.') <= 0) {
                        return false;
                    }                                       
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al seleccionar el csv. Favor de verificar que el archivo sea válido.",
                    footer: ""
                });                
            }

        },
        onFilePickedPdf(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.name_file_pdf = files[0].name;                    
                    this.archivo_original_pdf = files[0];
                    if (this.name_file_pdf.lastIndexOf('.') <= 0) {
                        return false;
                    }                    
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al seleccionar el PDF. Favor de verificar que el archivo sea válido.",
                    footer: ""
                });                
            }

        },
        onFilePickedMasivoCsv(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.name_file_masivo_csv = files[0].name;                    
                    this.archivo_original_masivo_csv = files[0];
                    if (this.name_file_masivo_csv.lastIndexOf('.') <= 0) {
                        return false;
                    }                    
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al seleccionar el PDF. Favor de verificar que el archivo sea válido.",
                    footer: ""
                });                
            }

        },
        onFilePickedMasivoPdf(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {
                    this.name_file_masivo_pdf = files[0].name;                    
                    this.archivo_original_masivo_pdf = files[0];
                    if (this.name_file_masivo_pdf.lastIndexOf('.') <= 0) {
                        return false;
                    }                    
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al seleccionar el ZIP. Favor de verificar que el archivo sea válido.",
                    footer: ""
                });                
            }

        },
        
        guardarDatos: function(){
            if (this.$refs.formdatos.validate()){
                this.saveFile(); 
            }            
        },

        saveFile: function(intento=1){
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var fecha_hora = moment().format("YYYYMMDDHHmmss");            
            var nuevo_nombre = fecha_hora + "_" + this.name_file.replace(".CSV",".csv"); //Agregamos la fecha al inicio, para evitar que se reemplacen archivos en S3
            var keyBucket = this.rfcActual + "/sa24_enproceso/" + nuevo_nombre;
            
            var nuevo_nombre_pdf = fecha_hora + "_" + this.name_file_pdf.replace(".PDF",".pdf");
            var keyBucketPdf = this.rfcActual + "/sa24_correcto/" + nuevo_nombre_pdf;
                    
            var datos = {
                key: keyBucket,
                bucket: "production.econnect.ds",
                type: "text/csv"
            }
            var self = this;
            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.archivo_original, {headers:{'Content-Type': "text/csv"}})
                        .then((res) => {
                            self.saveFilePdf(keyBucketPdf);

                            let data = {                                
                                key: keyBucket,
                                usuario_id: self.$local_storage.get("id_usuario"), 
                                usuario_name: self.$local_storage.get("nombre_usuario"), 
                                rfc: self.rfcActual,
                                tipo_archivo: "CTM",
                                origen: "WEB",  //WEB|SFTP

                                //Campos exclusivos para CTM
                                fecha_expedicion: self.fecha_expedicion,
                                anio: self.anio,
                                mes: self.mes,
                                rfc_iat: self.rfc_iat,
                                razon_social_iat: self.getNombreEmisor(self.rfc_iat),
                                emisor: self.getMetadatoEmisor(self.rfc_iat),
                                tipo_documento: self.tipo_documento,
                                folio_ctm: self.folio_ctm,
                                key_pdf: (this.name_file_pdf && this.name_file_pdf!="")?keyBucketPdf:"", 
                            };
                            axios.post(self.$apiSA31 + 'soluciona24/guarda_csv/', data)                            
                            .then(() => {
                                self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    html: `El archivo CSV está en proceso. Actualice la tabla más tarde haciendo clic en el icono 
                                        <i class="mdi mdi-refresh" style="color: #d1782d; font-size: 1.2em; padding: 0 5px;"></i>
                                        para ver su estatus.`,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.reset();
                                self.cargar();
                                this.modal = false;
                            }).catch((error) => {//ya que si el archivo es muy grande recibirá un timeOut
                                var mensaje = "Error al leer el archivo. Verifique que el archivo sea correcto e intente nuevamente.";
                                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                    mensaje = error.response.data.mensaje;
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.reset();
                                self.cargar();
                                this.modal = false;
                            });
                        }).catch((error)=>{
                            if(intento >= 3){
                                self.$root.$dialogLoader.hide();
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });                                
                                console.log(error);
                            } else {
                                self.saveFile(intento+1)
                            }
                            
                        });
                        
                    } else {
                        if(intento >= 3){
                            self.$root.$dialogLoader.hide();
                            self.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });                            
                        } else {
                            self.saveFile(intento+1)
                        }                        
                    }
                })
                .catch((error) => {
                    if(intento >= 3){
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        self.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);                        
                        this.$root.$dialogLoader.hide();                        
                    } else {
                        self.saveFile(intento+1)
                    }                    
                });

        },
        show_modal_pdf(id){
            this.reset();
            this.id_bitacora_seleccionado = id;
            this.modal_pdf = true;
        },
        guardarPDF: function(){
            if (this.$refs.formpdf.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                var fecha_hora = moment().format("YYYYMMDDHHmmss");            
                var nuevo_nombre_pdf = fecha_hora + "_" + this.name_file_pdf.replace(".PDF",".pdf");
                var keyBucket = this.rfcActual + "/sa24_correcto/" + nuevo_nombre_pdf;

                this.saveFilePdf(keyBucket);

                let data = {
                    key_pdf: keyBucket,
                    id_bitacora: this.id_bitacora_seleccionado
                }
                axios.post(this.$apiSA31 + 'soluciona24/actualiza_bitacora/', data)
                .then(() => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: 'El PDF se guardó correctamente.',
                        footer: ""
                    });                    
                }).catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: 'Ocurrió un error al guardar el PDF. Intente nuevamente por favor.',
                        footer: ""
                    });
                                        
                }).then(()=>{
                    this.modal_pdf = false;
                    this.$root.$dialogLoader.hide()
                    this.reset();
                    this.cargar();
                });

            }
        },
        saveFilePdf: function(key='', intento=1){
            if(this.name_file_pdf && this.name_file_pdf!=""){
                var keyBucket = key;
                    
                var datos = {
                    key: keyBucket,
                    bucket: "production.econnect.ds",
                    type: "application/pdf"
                }
                var self = this;
                axios.post(this.$hostname + 's3/upload_url/', datos)
                    .then((res) => {
                        if (typeof res.data !== 'undefined') {
                            var urlput = res.data.mensaje;
                            //console.log(urlput);
                            axios.put(urlput, self.archivo_original_pdf, {headers:{'Content-Type': "application/pdf"}})
                            .then((res) => {
                                //Pdf guardado                                                                
                            }).catch((error)=>{
                                if(intento >= 3){
                                    //Error al guardar el PDF
                                    console.log(error);
                                } else {
                                    self.saveFilePdf(key, intento+1)
                                }
                                
                            });
                            
                        } else {
                            if(intento >= 3){
                                console.log("Error al guardar el PDF");
                            } else {
                                self.saveFilePdf(key, intento+1)
                            }                        
                        }
                    })
                    .catch((error) => {
                        if(intento >= 3){
                            console.log("Excepción al guardar el PDF");
                        } else {
                            self.saveFilePdf(key, intento+1)
                        }                    
                    });
            }
            

        },

        reset() {
            try {
                const input = this.$refs.file_input;
                input.type = 'text';
                input.type = 'file';
                this.name_file = '';
                this.archivo_original = '';    
            } catch (error) {
                
            }
            
            try {
                const inputpdf = this.$refs.file_input_pdf;
                inputpdf.type = 'text';
                inputpdf.type = 'file';
                this.name_file_pdf = '';
                this.archivo_original_pdf = '';    
            } catch (error) {
                
            }            
        },
        resetMasivoCSV() {
            try {
                const input = this.$refs.file_input_masivo_csv;
                input.type = 'text';
                input.type = 'file';
                this.name_file_masivo_csv = '';
                this.archivo_original_masivo_csv = '';    
            } catch (error) {
                
            }
        },
        resetMasivoPDF() {
            try {
                const input = this.$refs.file_input_masivo_pdf;
                input.type = 'text';
                input.type = 'file';
                this.name_file_masivo_pdf = '';
                this.archivo_original_masivo_pdf = '';    
            } catch (error) {
                
            }
        },
        guardarMasivoCSV: function(intento=1){
            if (this.$refs.formpdf.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                var fecha_hora = moment().format("YYYYMMDDHHmmss");            
                var nuevo_nombre = fecha_hora + "_Historico_" + this.name_file_masivo_csv.replace(".CSV",".csv"); //Agregamos la fecha al inicio, para evitar que se reemplacen archivos en S3
                var keyBucket = this.rfcActual + "/sa24_enproceso/" + nuevo_nombre;
                
                var datos = {
                    key: keyBucket,
                    bucket: "production.econnect.ds",
                    type: "text/csv"
                }
                var self = this;
                axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.archivo_original_masivo_csv, {headers:{'Content-Type': "text/csv"}})
                        .then((res) => {                            

                            let data = {                                
                                key: keyBucket,
                                rfc: self.rfcActual, 
                                usuario_id: this.$local_storage.get("id_usuario"), 
                                usuario_name: this.$local_storage.get("nombre_usuario"),
                            };
                            axios.post(self.$apiSA31 + 'soluciona24/guarda_csv_masivo_ctm/', data)                            
                            .then(() => {
                                self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    html: `El archivo CSV está en proceso. Actualice la tabla más tarde haciendo clic en el icono 
                                        <i class="mdi mdi-refresh" style="color: #d1782d; font-size: 1.2em; padding: 0 5px;"></i>
                                        para ver su estatus.`,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.resetMasivoCSV();
                                self.cargar();
                                this.modal_masivo_csv = false;
                            }).catch((error) => {//ya que si el archivo es muy grande recibirá un timeOut
                                var mensaje = "Error al leer el archivo. Verifique que el archivo sea correcto e intente nuevamente.";
                                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                    mensaje = error.response.data.mensaje;
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.resetMasivoCSV();
                                self.cargar();
                                this.modal_masivo_csv = false;
                            });
                        }).catch((error)=>{
                            if(intento >= 3){
                                self.$root.$dialogLoader.hide();
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });                                
                                console.log(error);
                            } else {
                                self.guardarMasivoCSV(intento+1)
                            }
                            
                        });
                        
                    } else {
                        if(intento >= 3){
                            self.$root.$dialogLoader.hide();
                            self.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });                            
                        } else {
                            self.guardarMasivoCSV(intento+1)
                        }                        
                    }
                })
                .catch((error) => {
                    if(intento >= 3){
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        self.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);                        
                        this.$root.$dialogLoader.hide();                        
                    } else {
                        self.guardarMasivoCSV(intento+1)
                    }                    
                });

            }
        },
        guardarMasivoPDF: function(intento=1){
            if (this.$refs.formpdf.validate()){
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                var fecha_hora = moment().format("YYYYMMDDHHmmss");            
                var nuevo_nombre = fecha_hora + "_HistoricoPDFs_" + this.name_file_masivo_pdf.replace(".ZIP",".zip"); //Agregamos la fecha al inicio, para evitar que se reemplacen archivos en S3
                var keyBucket = this.rfcActual + "/sa24_enproceso/" + nuevo_nombre;
                
                var datos = {
                    key: keyBucket,
                    bucket: "production.econnect.ds",
                    type: "application/zip"
                }
                var self = this;
                axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, self.archivo_original_masivo_pdf, {headers:{'Content-Type': "application/zip"}})
                        .then((res) => {                            

                            let data = {                                
                                key: keyBucket,
                                rfc: self.rfcActual,                                 
                            };
                            axios.post(self.$apiSA31 + 'soluciona24/guarda_pdf_masivo_ctm/', data)
                            .then(() => {
                                self.$swal({
                                    type: "success",
                                    title: "Operación Exitosa",
                                    html: `El archivo ZIP está en proceso. Actualice la tabla más tarde haciendo clic en el icono 
                                        <i class="mdi mdi-refresh" style="color: #d1782d; font-size: 1.2em; padding: 0 5px;"></i>`,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.resetMasivoPDF();
                                self.cargar();
                                this.modal_masivo_pdf = false;
                            }).catch((error) => {//ya que si el archivo es muy grande recibirá un timeOut
                                var mensaje = "Error al leer el archivo. Verifique que el archivo sea correcto e intente nuevamente.";
                                if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                                    mensaje = error.response.data.mensaje;
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: mensaje,
                                    footer: ""
                                });
                                self.$root.$dialogLoader.hide()
                                self.resetMasivoPDF();
                                self.cargar();
                                this.modal_masivo_pdf = false;
                            });
                        }).catch((error)=>{
                            if(intento >= 3){
                                self.$root.$dialogLoader.hide();
                                self.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });                                
                                console.log(error);
                            } else {
                                self.guardarMasivoPDF(intento+1)
                            }
                            
                        });
                        
                    } else {
                        if(intento >= 3){
                            self.$root.$dialogLoader.hide();
                            self.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });                            
                        } else {
                            self.guardarMasivoPDF(intento+1)
                        }                        
                    }
                })
                .catch((error) => {
                    if(intento >= 3){
                        var mensaje = "Ocurrió un error al cargar el archivo. Favor de intentarlo de nuevo más tarde.";
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                            mensaje = error.response.data.mensaje;
                        self.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: mensaje,
                            footer: '',
                        });
                        console.log(error);                        
                        this.$root.$dialogLoader.hide();                        
                    } else {
                        self.guardarMasivoPDF(intento+1)
                    }                    
                });

            }
        },
        generateCSV() {
            // Datos a convertir en CSV
            const data = [                                
                {   folio_ctm:"CDM012021ARN0456",
                    mes: 1,
                    anio:2021,                    
                    secuencia:1,
                    emisor:"MAZDA",
                    no_parte:"PARTE12345",
                    descripcion:"MOLDURAS DE ACERO PARA USO AUTOMOTRIZ",
                    cantidad:1374,
                    pedimento:"16801003122",
                    aduana:"240",
                    fecha_pedimento:"2021-01-31",
                    mercado_exportacion:"A",
                    pais_exportacion:"NF",
                    comentarios:"ALGUN COMENTARIO AQUI"
                },
                {   folio_ctm:"CDM012021ARN0456",
                    mes: 1,
                    anio:2021,
                    secuencia:1,
                    emisor:"MAZDA",                    
                    no_parte:"PARTE12346",
                    descripcion:"PINTURA PARA USO AUTOMOTRIZ",
                    cantidad:490,                    
                    pedimento:"31471000503",
                    aduana:"270",
                    fecha_pedimento:"2021-01-31",
                    mercado_exportacion:"B",
                    pais_exportacion:"NF",
                    comentarios:"COMENTARIOS AQUI"
                    
                }
            ];

            const csvRows = [];
            // Añadir encabezados
            const headers = Object.keys(data[0]);
            csvRows.push(headers.join(',')); 

            // Añadir datos
            data.forEach(row => {
                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"'); // Manejar comillas
                    return `"${escaped}"`; // Envolver cada valor en comillas
                });
                csvRows.push(values.join(',')); // Cada fila en CSV
            });

            const csvContent = csvRows.join('\n');            
            const blob = new Blob([csvContent], { type: 'text/csv' });            
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'Ejemplo CTM.csv';
            link.click();
            URL.revokeObjectURL(link.href);
        },
        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
                return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {            
            if (!date) return null;
                return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
            },

        formatNumberDecCero: function(numero, decimales){
            if (numero == undefined || numero == null || numero == "")
                numero = 0;
            numero = Number(numero);
            if (isNaN(numero)){
                return "";
            } else{
              if(parseFloat(numero) == parseInt(numero))
                return numero.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              else
                return (numero).toFixed(decimales).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }    
        },

        cargar: function() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let data = {
                rfc: this.rfcActual,
                tipo: "CTM"
            };
            axios.post(this.$apiSA31 + 'soluciona24/get_bitacora_archivos/', data)                      
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.datos = res.data;
                    this.datos.sort(function(a, b) {
                        //Ordenar por fecha más reciente
                        return new Date(b.fecha) - new Date(a.fecha);
                    });
                    for (var k in this.datos) {
                        this.datos[k].fecha = this.parseDate(this.datos[k].fecha);   
                        if(this.datos[k].fecha_elimino){
                            this.datos[k].fecha_elimino = this.parseDate(this.datos[k].fecha_elimino);   
                        }
                        //Calculamos porcentaje, si el estatus es En Proceso
                        if (this.datos[k].estatus == "En Proceso" && this.datos[k].lineas_totales > 0){
                            var porcentaje = (this.datos[k].lineas_insertadas * 100) / this.datos[k].lineas_totales;
                            this.datos[k].estatus = "En Proceso: "+porcentaje.toFixed(0)+"%";
                        }
                    }
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener la bitácora.",
                    footer: ""
                });
                console.log(err);

            }).then(() => {
                this.$root.$dialogLoader.hide();
            });
        },
        downloadFile: function(key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                        footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        eliminar: function(idbitacora, nombre_archivo) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar la información del archivo: " + nombre_archivo + "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_bitacora: idbitacora,
                    usuario_id: this.$local_storage.get("id_usuario"), 
                    usuario_name: this.$local_storage.get("nombre_usuario"), 
                }
                axios.post(this.$apiSA31 + 'soluciona24/delete_bitacora_archivos/', datos)                 
                    .then((res) => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "La información se eliminó correctamente",
                            footer: ""
                        });
                        })
                        .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar la información. Intente nuevamente o comuníquese con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
                }
            });

        },
        eliminarRegistro: function(idbitacora, nombre_archivo) {
            //Solo Super Usuarios, solo se puede eliminar registro si está en estatus Eliminado(Se eliminó su informacion) o con Error(no se guardó informacion debido a errores)
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Se eliminará definitivamente el registro del archivo: " + nombre_archivo + ", ¿desea continuar?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    var datos = {
                        id_bitacora: idbitacora                    
                    }
                    axios.post(this.$apiSA31 + 'soluciona24/delete_registro_bitacora_archivos/', datos)                                
                    .then((res) => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente",
                            footer: ""
                        });
                        })
                        .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro. Intente nuevamente o comuníquese con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
                }
            });

        },
        eliminarRegistroMasivo: function() {
            //Solo Super Usuarios, solo se puede eliminar registro si está en estatus Eliminado(Se eliminó su informacion) o con Error(no se guardó informacion debido a errores)
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Se borrarán todos los registros que tengan error y los que su información haya sido eliminada previamente, ¿desea continuar?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                    const ids_bitacoras = this.datos.filter(r => ["Error", "Eliminado"].includes(r.estatus)).map(r => r._id);
                    var datos = {
                        ids: ids_bitacoras                    
                    }
                    axios.post(this.$apiSA31 + 'soluciona24/delete_masivo_registro_bitacora_archivos/', datos)                                
                    .then((res) => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "Los registros se eliminaron correctamente",
                            footer: ""
                        });
                        })
                        .catch((error) => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar registros. Intente nuevamente o comuníquese con soporte.",
                            footer: '',
                        });
                        console.log(error);
                    }).then(() => {
                        this.$root.$dialogLoader.hide();
                        this.cargar();
                    });
                }
            });

        },
        generar_reporte_sqs() {
            if (!this.$refs.formreporte.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var data = Vue.util.extend({}, this.model);

                if (data.lista == '' || data.lista == []) {
                    delete(data['lista']);
                } else {
                    data['lista'] = this.get_array_lista(data['lista']);                                      
                }
                
                axios({
                    method: "post",
                    url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",                    
                    data: data
                })
                .then(response => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
                        footer: ""
                    });
                })
                .catch(error => {
                    let mensaje;
                    var titulo = "¡Operación no Permitida!";
                    var tipo = "error";
                    if (typeof error.response !== "undefined") {
                        mensaje = error.response.data.mensaje;
                        if (error.response.status == 406) {
                            titulo = "¡Ya existe un reporte en proceso!";
                            tipo = "info";
                        }
                    } else {
                        mensaje = "Ocurrió un error al generar el reporte";
                    }
                    this.$swal({
                        type: tipo,
                        title: titulo,
                        text: mensaje,
                        footer: ""
                    });
                }).then(() => {
                    this.cargarReportes();
                    this.$root.$dialogLoader.hide();
                });
            }
        },
        eliminarReporte: function(idreporte) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var datos = {
                    id_reporte: idreporte,
                }
                axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
                    .then((res) => {
                    this.$swal({
                        type: "success",
                        title: "Operación Exitosa",
                        text: "El reporte se eliminó correctamente",
                        footer: ""
                    });
                    })
                    .catch((error) => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                        footer: '',
                    });
                    console.log(error);
                    }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.cargarReportes();
                    });
                }
            });
        },
    }
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small ;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small ;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>